
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as patxpe9uq6LYdARZSj7hPJpPPkLJzOta0RNatbXZ5wyPwsMeta } from "/app/pages/pat.vue?macro=true";
import { default as newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta } from "/app/pages/news.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as powerXu2ag0TpIjhqUpn4fxBmLfnKpMvNvfICecxAZEvkZTcMeta } from "/app/pages/power.vue?macro=true";
import { default as usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta } from "/app/pages/users.vue?macro=true";
import { default as tenantn0D5NPh_M4rtrhtYLr5MZFxtHs3Iu7DFUlV91HfhIsYMeta } from "/app/pages/tenant.vue?macro=true";
import { default as contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta } from "/app/pages/contact.vue?macro=true";
import { default as profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta } from "/app/pages/profile.vue?macro=true";
import { default as ticketsn5mbygfShrFxyvU2Jb7Nh3qgDl7n8f3LI19NoabMzLUMeta } from "/app/pages/tickets.vue?macro=true";
import { default as trafficA_rid0nxXin1nLs3TX7DDUTO8yuRwLOO9QKN8EBRpT0Meta } from "/app/pages/traffic.vue?macro=true";
import { default as invoicesnT9ORehNYI0qjYgCof5IJgyKP5iYKKWQZmqLFoNOZtAMeta } from "/app/pages/invoices.vue?macro=true";
import { default as dashboardMP4s_45_45Pnrs3lAogdEWxQSVgBglFzEw4XrIvkluYCTzEMeta } from "/app/pages/dashboard.vue?macro=true";
import { default as documentsnySbyr2WnGLxD8HHuPmsjpznGSLSMl3b7IkVDraAXt8Meta } from "/app/pages/documents.vue?macro=true";
import { default as employeesvJX8OOMdO2m1eXyl6xstp4Ff2RH128KjCAVVx7TxHP8Meta } from "/app/pages/employees.vue?macro=true";
import { default as permissionseZNWYkKVui6eCCssuowxz3khlCPpLdsvK0YaaOEfb74Meta } from "/app/pages/permissions.vue?macro=true";
export default [
  {
    name: "pat",
    path: "/pat",
    meta: patxpe9uq6LYdARZSj7hPJpPPkLJzOta0RNatbXZ5wyPwsMeta || {},
    component: () => import("/app/pages/pat.vue")
  },
  {
    name: "news",
    path: "/news",
    meta: newsDP_WXM_4YAJIFDG9XLtzxpTjkSgEFaVqkwGmWs0FfJ0Meta || {},
    component: () => import("/app/pages/news.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta || {},
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "power",
    path: "/power",
    meta: powerXu2ag0TpIjhqUpn4fxBmLfnKpMvNvfICecxAZEvkZTcMeta || {},
    component: () => import("/app/pages/power.vue")
  },
  {
    name: "users",
    path: "/users",
    meta: usersfwkWStBj7bsR6vrbpmu_yeS56djFcxtb3JU1R98uVV4Meta || {},
    component: () => import("/app/pages/users.vue")
  },
  {
    name: "tenant",
    path: "/tenant",
    meta: tenantn0D5NPh_M4rtrhtYLr5MZFxtHs3Iu7DFUlV91HfhIsYMeta || {},
    component: () => import("/app/pages/tenant.vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: contactufjgRVR80M94tPXoOoARnsatRQ8kqFsigR6NqG_45FbxIMeta || {},
    component: () => import("/app/pages/contact.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: profilepJO2Lu3IltPzloUxFV8Oe0uuAaiSUhc1LFMplh8Hci0Meta || {},
    component: () => import("/app/pages/profile.vue")
  },
  {
    name: "tickets",
    path: "/tickets",
    meta: ticketsn5mbygfShrFxyvU2Jb7Nh3qgDl7n8f3LI19NoabMzLUMeta || {},
    component: () => import("/app/pages/tickets.vue")
  },
  {
    name: "traffic",
    path: "/traffic",
    meta: trafficA_rid0nxXin1nLs3TX7DDUTO8yuRwLOO9QKN8EBRpT0Meta || {},
    component: () => import("/app/pages/traffic.vue")
  },
  {
    name: "invoices",
    path: "/invoices",
    meta: invoicesnT9ORehNYI0qjYgCof5IJgyKP5iYKKWQZmqLFoNOZtAMeta || {},
    component: () => import("/app/pages/invoices.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardMP4s_45_45Pnrs3lAogdEWxQSVgBglFzEw4XrIvkluYCTzEMeta || {},
    component: () => import("/app/pages/dashboard.vue")
  },
  {
    name: "documents",
    path: "/documents",
    meta: documentsnySbyr2WnGLxD8HHuPmsjpznGSLSMl3b7IkVDraAXt8Meta || {},
    component: () => import("/app/pages/documents.vue")
  },
  {
    name: "employees",
    path: "/employees",
    meta: employeesvJX8OOMdO2m1eXyl6xstp4Ff2RH128KjCAVVx7TxHP8Meta || {},
    component: () => import("/app/pages/employees.vue")
  },
  {
    name: "permissions",
    path: "/permissions",
    meta: permissionseZNWYkKVui6eCCssuowxz3khlCPpLdsvK0YaaOEfb74Meta || {},
    component: () => import("/app/pages/permissions.vue")
  }
]